import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { Skeleton, useFeatureFlag } from '@medifind/shared-basic-components';
import ClinicalTrialRequest from './ClinicalTrialRequest/ClinicalTrialRequest';
import styles from './ClinicalTrialShared.module.scss';

const ClosestLocation = ({ address, trialName, contacts, distance }) => {
  const { orgName, city, stateProvinceCode, countryCode, country } = address;
  const addressLine = `${stateProvinceCode ? city : city + ','} ${stateProvinceCode ? stateProvinceCode + ',' : ''} ${
    countryCode === 'USA' ? countryCode : country
  } (${distance} away)`;

  return (
    <Row>
      <Col>
        <span className={classNames(styles['section-body-text'], styles['bold'])}>Closest Recruiting Location: </span>
        <div></div>
        <ClinicalTrialRequest trialName={trialName} location={address} contacts={contacts}>
          <div className={classNames(styles['section-body-text'], styles['clickable'], styles['indent'])}>{orgName}</div>
        </ClinicalTrialRequest>
        <div className={classNames(styles['section-body-text'], styles['indent'])}>{addressLine}</div>
      </Col>
    </Row>
  );
};

const ClinicalTrialGenInfo = ({
  isLoading,
  addressCount,
  studyType,
  interventionType,
  status,
  phase,
  patientPopulation,
  primaryTreatment,
  startDate,
  publicationDate,
  handleLocationScroll,
  closestLocation,
  contacts,
  trialName,
}) => {
  const FEATURE_FLAG_TRIAL_CONNECT = useFeatureFlag('TRIAL_CONNECT');

  return (
    <div className={styles['article__ct-geninfo']}>
      {patientPopulation ? (
        <div>
          Who is this study for? <span>{patientPopulation}</span>
        </div>
      ) : null}
      {primaryTreatment ? (
        <div>
          What treatments are being studied? <span>{primaryTreatment}</span>
        </div>
      ) : null}
      {isLoading || startDate ? (
        <div>
          {startDate ? (
            <>
              Start Date: <span>{startDate}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {isLoading || publicationDate ? (
        <div>
          {publicationDate ? (
            <>
              Publish Date: <span>{publicationDate}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {isLoading || status ? (
        <div>
          {status ? (
            <>
              Status: <span>{status}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {isLoading || addressCount > 0 ? (
        <div>
          {!isLoading ? (
            <>
              {closestLocation && closestLocation.address ? (
                <ClosestLocation
                  address={closestLocation.address}
                  distance={closestLocation.distance}
                  contacts={closestLocation.contacts}
                  trialName={trialName}
                />
              ) : (
                <span className={classNames(styles['section-body-text'], styles['bold'])}>Location: </span>
              )}
              <span
                className={classNames(styles['section-body-text'], styles['clickable'], { [styles['indent']]: closestLocation })}
                onClick={handleLocationScroll}
              >
                {addressCount > 1 ? `See all (${addressCount}) locations...` : `See location...`}
              </span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {isLoading || interventionType ? (
        <div>
          {interventionType ? (
            <>
              Intervention Type: <span>{interventionType}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {isLoading || studyType ? (
        <div>
          {studyType ? (
            <>
              Study Type: <span>{studyType}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {isLoading || phase ? (
        <div>
          {phase ? (
            <>
              Study Phase: <span>{phase}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {process.env.NX_APP === 'MediFind' && (isLoading || status === 'Recruiting') ? (
        <div className={styles['connect-button-row']}>
          {!isLoading ? (
            !FEATURE_FLAG_TRIAL_CONNECT ||
            (closestLocation?.address?.contacts ? closestLocation?.address?.contacts : contacts).length > 0 ? (
              <ClinicalTrialRequest
                trialName={trialName}
                label="Connect me to this trial"
                location={closestLocation ? closestLocation.address : null}
                contacts={contacts}
              />
            ) : null
          ) : (
            <Skeleton height={36} width={250} />
          )}
        </div>
      ) : null}
    </div>
  );
};

export { ClinicalTrialGenInfo as default, ClinicalTrialGenInfo };
